import styled from "styled-components";
import {MapContainer} from "../../../order/orderDetail/orderDetailStyles";

export const StyledMapContainer = styled(MapContainer)`
    height: ${props => (props.mode === "relative" ? "100%" : "400px")};
`;

export const CustomMarker = styled.div`
    position: relative;
    width: 36px;
    height: 36px;
    background: ${props =>
        props.isDepot ? `linear-gradient(145deg, ${props.color} 0%, #000000 100%)` : props.color};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
    color: white;
    font-weight: bold;
    font-size: 14px;

    &:after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${props => props.color};
    }

    &:hover {
        transform: translate(-50%, -50%) scale(1.1);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);

        & + .tooltip {
            opacity: 1;
            visibility: visible;
            transform: translateY(-45px);
        }
    }
`;

export const TooltipBox = styled.div`
    position: absolute;
    background: white;
    padding: 4px 8px;
    border-radius: 10px;
    border: 2px solid ${props => props.color};
    color: ${props => props.color};
    font-weight: bold;
    font-size: 16px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    transform: translateY(-35px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    pointer-events: none;
`;

export const MarkerContainer = styled.div`
    position: relative;
`;
